export default __webpack_public_path__ + "static/media/Group9224.cf1fe0a0.svg";